<template>
  <div>
    <div class="schedule-wrapper mt-2">
      <b-modal
        id="modal-resume"
        centered
        title="You have an Unfinished Test"
        ok
        hide-footer
        hide-header
      >
        <p>
          You have an Unfinished Test which will resume in {{ countdown }}secs
        </p>
      </b-modal>
      <div class="flex-parent text-center p-1">
        <p class="flex-child">{{ schedule.scheduled_category }}</p>
        <p class="flex-child">{{ schedule.scheduled_institution_shortname }}</p>
        <p class="flex-child">{{ schedule.scheduled_mode }} Mode</p>
        <p class="flex-child">{{ scheduledate }}<br />{{ scheduletime }}</p>
        <p class="flex-child text-left" v-if="type == 'up'">
          {{ schedule.message }} <br />
          <b-overlay
            :show="proceeding"
            rounded
            opacity="0.6"
            spinner-small
            spinner-variant="primary"
            class="w-100"
          >
            <b-button
              type="submit"
              :disabled="!takeable"
              class=" p-2 v-button p-lg-2"
              :class="from == 'dashhome' ? 'smaller-button' : ''"
              variant="success"
              @click="takeTest()"
            >
              Take
            </b-button>
          </b-overlay>
        </p>
        <p class="flex-child" v-if="type == 'past'">
          {{ schedule.message }}<br />
          <b-overlay
            :show="proceeding"
            rounded
            opacity="0.6"
            spinner-small
            spinner-variant="primary"
            class="w-100"
          >
            <b-button
              :to="{
                name: 'breakdown',
                params: { trackid: schedule.schedule_test_tid }
              }"
              v-if="schedule.schedule_status == 'Taken'"
              class="p-2 v-button v-button2 p-lg-2"
              :class="from == 'dashhome' ? 'smaller-button' : ''"
              variant="info"
            >
              View result
            </b-button>
          </b-overlay>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  props: ["schedule", "type", "from"],
  data() {
    return {
      randnum: Math.round(Math.random(1, 10) * 5),
      colorarr: ["red", "yellow", "green", "purple", "blue", " bluedepth"],
      scheduledate: "",
      scheduletime: "",
      select: this.getselected(),
      countdown: 5,
      todaydate: "",
      todaytime: "",
      stimehour: "",
      stimeminutes: "",
      monthArray: [
        "Jan",
        "Feb",
        "Mar",
        "April",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec"
      ],
      proceeding: false,
      takeable: false
    };
  },
  created() {},
  mounted() {
    this.dataFormatter();

    this.chktakeability();

    setInterval(this.chktakeability, 60000);
  },
  methods: {
    ...mapActions("exam", ["setSelect"]),
    dataFormatter() {
      let sdate = new Date(
        `${this.schedule.scheduled_date + " " + this.schedule.scheduled_time}`
      );
      let sdatestring =
        this.monthArray[sdate.getMonth()] +
        " " +
        sdate.getDate() +
        ", " +
        sdate.getFullYear();
      this.scheduledate = sdatestring;
      // console.log(sdate)
      let stimestring =
        (sdate.getHours() <= 12 ? sdate.getHours() : sdate.getHours() - 12) +
        ":" +
        (sdate.getMinutes() < 10
          ? `0${sdate.getMinutes()}`
          : sdate.getMinutes()) +
        (sdate.getHours() < 12 ? "am" : "pm");
      this.stimehour = sdate.getHours();
      this.stimeminutes = sdate.getMinutes();
      this.scheduletime = stimestring;
      // console.log(stimestring)
    },
    getselected() {
      return {
        organization: this.$store.state.loginmaster.details.quicktest_details.organization_name,
        organization_id: this.$store.state.loginmaster.details.quicktest_details.track_id,
        category: null,
        institution: null,
        institution_id: null,
        level: null,
        course: null,
        scholarship: null,
        subjects: [],
        topics: [],
        reducer: 25,
        questionspertopic: 5,
        minutesperquestion: 1,
        mode: "Prototype",
        testspaceid: "",
        testsource: "scheduler",
        structure: "",
        schedule_trackid: "",
        candidate: this.$store.state.loginmaster.details
      };
    },
    takeTest() {
      // this.select.organization = this.schedule.organization
      this.select.category = this.schedule.scheduled_category;
      this.select.institution = this.schedule.scheduled_institution;
      this.select.institution_id = this.schedule.scheduled_institution_id;
      this.select.level = this.schedule.scheduled_level;
      this.select.course = this.schedule.scheduled_course;
      this.select.subjects = this.schedule.scheduled_subjects;
      this.select.mode = this.schedule.scheduled_mode;
      this.select.structure = this.schedule.scheduled_structure;
      this.select.reducer = this.schedule.scheduled_mode_config[0].reducer;
      this.select.questionspertopic = this.schedule.scheduled_mode_config[0].questionspertopic;
      this.select.minutesperquestion = this.schedule.scheduled_mode_config[0].minutesperquestion;
      // this.select.testspaceid = this.usecurrenttestspace.trackid
      this.select.candidate = this.details;
      this.select.schedule_trackid = this.schedule.track_id;

      this.proceeding = true;
      // console.log(this.select)
      return this.setSelect(this.select).then(() => {
        this.proceeding = false;
        // If the Request went successfully and the Test Parameter has been sent back then proceed to confirm the Test Parameters and Start the Test
        // console.log(this.ongoing)
        // console.log(this.start_config.start)
        if (this.ongoing) {
          // this.countdown = this.countdown - 1;
          this.$bvModal.show("modal-resume");
          this.reduceCountdown();
        } else if (this.start_config.start == "Yes") {
          this.$router.push({
            name: "confirm"
          });
        }
      });
    },
    movedown() {
      let categoryName = JSON.parse(this.start_config.category).name;
      // console.log( JSON.parse(this.start_config.category).name)
      this.$router.push({
        name: "testhall",
        params: {
          trackid: this.start_config.track_id,
          category: categoryName,
          institution: this.start_config.institution_shortname
        }
      });
    },
    reduceCountdown() {
      this.countdown = this.countdown - 1;
      setTimeout(() => {
        // this.countdown = this.countdown - 1;
        this.reduceCountdown();
        if (this.countdown == 0) {
          this.movedown();
        }
      }, 1000);
    },
    chktakeability() {
      // console.log("checking takability")
      let tdate = new Date();
      let tdatestring =
        this.monthArray[tdate.getMonth()] +
        " " +
        tdate.getDate() +
        ", " +
        tdate.getFullYear();
      let ttimehour = tdate.getHours();
      let ttimeminutes = tdate.getMinutes();
      // this.todaydate = tdatestring

      // console.log("<br>" + ttimehour)
      // console.log(this.stimehour + "<br>")
      if (tdatestring == this.scheduledate) {
        // console.log("Today--" + this.type)

        if (ttimehour == this.stimehour) {
          if (ttimeminutes >= this.stimeminutes) {
            this.takeable = true;
          }
        } else if (ttimehour > this.stimehour) {
          this.takeable = true;
        } else {
          this.takeable = false;
        }
      } else {
        // console.log("Not today--" + this.type)
        this.takeable = false;
      }

      // console.log(this.takeable)
    }
  },
  computed: {
    ...mapState({
      details: state => state.loginmaster.details,
      ongoing: state => state.ongoing,
      start_config: state => state.exam.start_config
    })
  }
};
</script>

<style scoped>
.schedule-wrapper {
  border-radius: 10px 10px;
  background-color: rgba(247, 247, 247, 0.927);
  padding: 4px;
}

.colodiv {
  width: 20%;
}

.detailsdiv {
  width: 80%;
}

.color {
  width: 90%;
  height: 35px;
  border-radius: 10px 10px;
}

.bluedepth {
  background-color: #00377b;
}

.red {
  background-color: red;
}

.yellow {
  background-color: yellow;
}

.green {
  background-color: green;
}

.purple {
  background-color: purple;
}

.blue {
  background-color: blue;
}

.slfl {
  display: flex;
}

.exty {
  width: 50%;
  font-size: 1rem;
  font-weight: bolder;
}

.calendar {
  width: 60%;
  line-height: 17px;
  color: gray;
}

.cadate {
  font-size: 0.83rem;
}

.catime {
  font-size: 0.75rem;
  font-weight: bolder;
}

.institu {
  font-size: 0.8rem;
  color: gray;
  display: flex;
}

.insti {
  width: 90%;
  font-weight: bolder;
}

.icon {
  width: 10%;
  margin-left: -1px;
}
.flex-parent {
  display: flex;
  flex-flow: row nowrap;
  /* height: 35px; */
  justify-content: space-between;
  overflow-x: auto;
  /* white-space: nowrap; */
  scrollbar-width: thin;
}

.flex-child {
  width: 18%;
  padding: 3px;
  /* font-size: 0.8rem; */
}

.v-button {
  border-radius: 10px 10px;
  width: 10rem;
  /* height: 3rem; */
  background-color: #00984a;
  font-weight: bolder;
  color: white;
  position: relative;
  bottom: -80%;
  border: 0px;
  font-size: 18px;
  cursor: pointer;
}
.v-button:hover {
  background-color: white;
  color: #00984a;
  border: 1px solid #00984a;
}

.v-button2 {
  background-color: #00377b;
}

.v-button2:hover {
  background-color: white;
  color: #00377b;
  border: 1px solid #00377b;
}

.smaller-button {
  width: inherit;
  /* height: 2.5rem; */
  font-size: 0.8rem;
}

@media screen and (max-width: 999px) {
  .flex-child {
    width: 18%;
    padding: 3px;
    font-size: 0.82rem;
  }
  .v-button {
    width: inherit;
    /* height: 2.5rem; */
    font-size: 0.8rem;
  }
}
</style>
